import { render } from "./customSelect.vue?vue&type=template&id=7a83c255&scoped=true"
import script from "./customSelect.vue?vue&type=script&lang=js"
export * from "./customSelect.vue?vue&type=script&lang=js"

import "./customSelect.vue?vue&type=style&index=0&id=7a83c255&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a83c255"]])

export default __exports__